import { type FunctionComponent } from 'react';

import { InputGroup } from '@blueprintjs/core';

import { handleNumberOnly, testAttribute } from '../../../../util/Util';

interface NumberFilterInputProps {
  value: string;
  onChange: (newValue: string) => void;
  label?: string;
  filterKey: string;
}

export const NumberFilterInput: FunctionComponent<NumberFilterInputProps> = ({ value, onChange, label, filterKey }) => (
  <>
    <span className="lib-table-filter__label">{label}</span>
    <InputGroup
      data-test-id={testAttribute('nufi', 'table-filter.number-input', filterKey)}
      value={value ?? ''}
      type="number"
      fill
      onChange={(event: any) => onChange(event.target.value)}
      onKeyDown={e => handleNumberOnly(e)}
    />
  </>
);
